import React from "react";
import NationalCartographyView from "../components/NationalCartography/NationalCartographyView";
import "../components/NationalCartography/NationalCartography.css";

const NationalCartography: React.FC = () => {
  return (
    <div className="flex-grow-1 container-p-y national-cartography-page">
      <NationalCartographyView />
    </div>
  );
};

export default NationalCartography;
